/*
  Project: MDLL
  Author: Marcin Krzemiński
 */
import 'focus-within-polyfill';
import cssVars from 'css-vars-ponyfill';
import './modules/navigation';
import './modules/slider';
import './modules/tabs';

cssVars();



// WEBPACK FOOTER //
// ./src/scripts/app.js